
import { defineComponent, ref, onMounted, watch } from "vue";
import ApiService from "@/core/services/ApiService";
import { useStore } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { emit } from "process";

export default defineComponent({
  name: "admin-task-drawer",
  emits: ["submit"],
  props: {
    merchant: Object,
    merchantID: String,
    merchantURL: String,
  },
  setup(props, { emit }) {
    const tasksPendingTotal = ref(0);
    const tasksReviewedTotal = ref(0);
    const tasksPending = ref([]);
    const tasksReviewed = ref([]);
    const loading = ref(false);
    const taskResetLoading = ref(false);
    const taskDeleteLoading = ref(false);

    watch(
      () => props.merchantID,
      async () => {
        if (props.merchantID) {
          await getPendingTasks();
          await getReviewedTasks();
        }
      }
    );

    const getReviewedTasks = async () => {
      loading.value = true;
      const res2 = await ApiService.get(
        `merchants/tasks?merchant_id=${props.merchantID}&reviewed=1`
      );
      tasksReviewed.value = res2.data.data;
      tasksReviewedTotal.value = res2.data.meta.total;

      loading.value = false;
    };
    const getPendingTasks = async () => {
      loading.value = true;
      const res = await ApiService.get(
        `merchants/tasks?merchant_id=${props.merchantID}&reviewed=0`
      );
      tasksPending.value = res.data.data;
      tasksPendingTotal.value = res.data.meta.total;
      loading.value = false;
    };

    const checked = ref(false);

    const onUpdateTask = async (index, status, text, color) => {
      let payload: any = "";
      loading.value = true;
      try {
        const res = await ApiService.put(
          `merchants/tasks/${index}?reviewed=1&status=${status}&text=${text}&color=${color}`,
          payload
        );
        if (res.data.success) {
          Swal.fire({
            text: "Task Reviewed!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            getReviewedTasks();
            getPendingTasks();
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
      loading.value = false;
    };
    const onResetTask = async (index) => {
      let payload: any = "";
      taskResetLoading.value = true;
      try {
        const res = await ApiService.put(
          `merchants/tasks/${index}?reviewed=0&status=Review&text=text-gray-600&color=bg-light`,
          payload
        );
        if (res.data.success) {
          Swal.fire({
            text: "Task Reset!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            getReviewedTasks();
            getPendingTasks();
            emit("submit");

          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
      taskResetLoading.value = false;
    };
    const onDeleteTask = async (index) => {
      taskDeleteLoading.value = true;
      try {
        const res = await ApiService.delete(`merchants/tasks/${index}`);
        if (res.data.success) {
          Swal.fire({
            text: "Task Deleted!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            getReviewedTasks();
            getPendingTasks();
            emit("submit");
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
      taskDeleteLoading.value = false;
    };

    return {
      onResetTask,
      onDeleteTask,
      onUpdateTask,
      tasksReviewed,
      tasksPending,
      tasksPendingTotal,
      tasksReviewedTotal,
      checked,
      taskDeleteLoading,
      taskResetLoading,
    };
  },
});
